<template>
	<!-- Vue Material SelectItem -->
	<!-- https://vuematerial.io/components/select -->

	<md-option
		:disabled="disabled"
		:value="value"
	>
		{{ label }}
	</md-option>
</template>

<script>
export default {
	name: "SelectItem",
	props: {
		disabled: {
			type: Boolean,
			default: false,
			required: false
		},
		label: {
			type: String,
			default: "",
			required: false
		},
		value: {
			type: [String, Number],
			default: "",
			required: false
		}
	}
};
</script>
